import ToggleGroupComponent from 'components/ToggleGroup';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';
import React from 'react';
import { capabilities } from 'utils/configs';
import { uniq } from 'utils/index';

const Capabilities = ({ capas, newCapas, onChangeCapas }: ICapabilities) => {
  const [newlyAddedCapas, setNewlyAddedCapas] = React.useState<string[]>([]);
  const [otherCapability, setOtherCapability] = React.useState<string>('');

  // Unselected capablities that are configured in the app
  const possiblePreConfiguredCapas = capabilities.filter(c => !capas.includes(c));

  const onChange = (revisedCapas: string[]) => {
    onChangeCapas(uniq(revisedCapas));
  };

  return (
    <div>
      <div className="mb-5">
        <ToggleGroupComponent
          value={newCapas ? newCapas : capas}
          onChange={value => onChange(value)}
          header={'Current capabilities'}
          options={[...capas, ...newlyAddedCapas]}
        />
      </div>
      <ToggleGroupComponent
        value={newCapas ? newCapas : capas}
        onChange={value => onChange(value)}
        header={'Possible capabilities'}
        options={possiblePreConfiguredCapas}
      />

      <div className="mt-5 mb-8">
        <Button
          variant={'outline'}
          className="h-11"
          onClick={() => {
            if (newCapas) {
              onChange([...newCapas, ...possiblePreConfiguredCapas]);
            } else {
              onChange([...capas, ...possiblePreConfiguredCapas]);
            }
          }}
        >
          Enable all possible capabilities
        </Button>
      </div>
      <div className="my-4">
        <Label htmlFor="newCapa">Add other capability</Label>
        <Input
          type="text"
          id="newCapa"
          placeholder="Other capability"
          value={otherCapability}
          onChange={e => setOtherCapability(e.target.value)}
          className="w-100"
        />
        <Button
          variant={'outline'}
          className="h-9 mx-5"
          onClick={() => {
            if (newlyAddedCapas.includes(otherCapability)) return;
            if (newCapas) {
              onChange([...newCapas, otherCapability]);
            } else {
              onChange([...capas, otherCapability]);
            }
            setNewlyAddedCapas([...newlyAddedCapas, otherCapability]);
            setOtherCapability('');
          }}
        >
          Add
        </Button>
      </div>
    </div>
  );
};

interface ICapabilities {
  capas: string[];
  newCapas?: string[];
  onChangeCapas: (capas: string[]) => void;
}

export default Capabilities;
